import { Link, useLocation } from "react-router-dom"
import { cn } from "../../lib/utils"

export default function Navbar () {
  const pathName = useLocation().pathname
  return (
    <nav className="flex gap-4">
      <Link to={"/"} className={cn("cursor-pointer", pathName==="/" ? "font-black text-primary" : "")}>Home</Link>
      <Link to={"/courses"}  className={cn("cursor-pointer", pathName.startsWith("/courses") ? "font-black text-primary" : "")}>Courses</Link>
      <Link to={"/instructor"}   className={cn("cursor-pointer", pathName==="/instructor" ? "font-black text-primary" : "")}>Instructor</Link>
      <Link to={"/about"}  className={cn("cursor-pointer", pathName==="/about" ? "font-black text-primary" : "")}>About</Link>
    </nav>
  )
}
